import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function InfoIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M12 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1M12 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
        <path d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18" />
      </>
    </Icon>
  );
}

InfoIcon.displayName = 'InfoIcon';
